import { Outlet, Navigate } from "react-router-dom";

const WinderRoutes = (props) => {
   return props.winder ? <Outlet /> : <Navigate to="/login" />;
};

export default WinderRoutes;
